import { useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { orderGridValidateAddress } from '../../../store/orders/grid/orders.grid.header.actions';
import { useOneOrMoreOrderSelectedDisabled } from '../disabled-hooks/use-one-or-more-order-selected-disabled';
import { messages } from './messages';

export const useValidateAddress = () => {
  const dispatch = useDispatch();
  const oneOrMoreOrderSelectedDisabled = useOneOrMoreOrderSelectedDisabled();

  const actionHandler = useCallback(() => {
    dispatch(orderGridValidateAddress());
  }, [dispatch]);

  return useMemo(() => {
    return {
      actionHandler,
      nameDescriptor: messages.orderGridOtherActionsValidateAddress,
      isDisabled: oneOrMoreOrderSelectedDisabled,
      disabledReason: null,
    };
  }, [actionHandler, oneOrMoreOrderSelectedDisabled]);
};
